module.exports = __webpack_public_path__ + "img/yellow.b2a04bf0.png";